import React, {useState, useEffect} from 'react';
import {Form, Button, Alert, Spinner} from 'react-bootstrap';
import {Formik} from 'formik';
import axios from 'axios';
import {apiUrl} from '../../../util/Api';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../../app/slices/UserSlice';

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
    email: Yup.string().email('please enter a valid email').required('email is required'),
    roleId: Yup.string().required('a role is required.')
  });

const AccountInviteForm = ({updateInvites, ...props}) => {
  //console.log("show AccountInviteForm")
  const accountKey = props?.accountKey ? props.accountKey : '';
  const userLimit = props?.userLimit ? props.userLimit : 0;
  const userCount = props?.userCount ? props.userCount : 0;
  //const inviteCount = props.inviteCount ? props.inviteCount : 0;
  const invites = props?.invites ? props.invites : [];
  
  const [errors, setErrors] = useState([]);
  const [successMsg, setSuccessMsg] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [roles, setRoles] = useState([]);

  const [inviteFormVisible, setInviteFormVisible] = useState(false)

  const submitSubmit = (values, actions) => {
    //console.log("submitting form", values);
    setSubmitting(true)
    setErrors([]);
    setSuccessMsg(null);

    axios.post(apiUrl + '/invites/add', values, {withCredentials: true})
    .then((res) => {
      if(res.data.status === "ok") {
        setErrors([]);
        //update info at all?
        //set cookie
        //setAuthentication(res.data.user, persist);
        //dispatch?
        //dispatch(saveUserStore(res.data.user));
        //hide form
        //setVisible(false);
        setSuccessMsg('The invite was sent.')
        setInviteFormVisible(false);
        let temp = [...invites]
        let invite = res.data.invite;
        invite.created = new Date().toLocaleDateString();
        temp.push(invite);
        updateInvites(temp);
      }
      else {
        //console.log('an error was returned');
        //display errors
        //clearAuthentication();
        //dispatch(clearUserStore());
        let errorMsgs = [];
        //reset TOS link?
        //values.tosAgree = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'no-permissions':
              errorMsgs.push('You do not have permissions to invite users.');
              break;
            case 'over-limit':
            errorMsgs.push('You are at the limit for users on the account. Contact us to add more.');
            break;
            default:
              errorMsgs.push('There was an error sending the invite.');
          }
        });
        setErrors(errorMsgs);
      }
      setSubmitting(false)
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      //clearAuthentication();
      //dispatch(clearUserStore());
      setErrors(['An error occurred while sending the invite.']);
      setSubmitting(false)
    });
  }

  useEffect(() => {
    axios.get(apiUrl + '/accounts/roles', {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        //remove owner option 
        let roles = res.data.roles; 
        
        //setRoles(roles.filter(role => role.role.toLowerCase() != 'owner'));
        setRoles(roles.filter(role => role.roleId >0 && role.roleId < 3));
      }
    })
    .catch((err) => {

    });
  },[accountKey]);

  //check if logged in
  return (
    <div>
      <Button  onClick={() => setInviteFormVisible(!inviteFormVisible)} size='sm'>Invite User</Button>

      {
        errors.length > 0 ? (
          <Alert variant='danger' className='my-3'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        successMsg !== null ? (
          <Alert variant='info' className='my-3'>
          {successMsg}
          </Alert>
        ) : (null)
      }

      {inviteFormVisible ? (
        <div className='chart-card mt-3'>
        <Formik validationSchema={validationSchema}
        onSubmit={submitSubmit}
        initialValues={{email: '',accountKey: accountKey, roleId:''}}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors
        }) => (
          <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
            <Form.Group controlId='invite-email' className='mb-3'>
            <Form.Label>Recipient's Email</Form.Label>
            <Form.Control type="email" placeholder="email"
              name="email" value={values.email} onChange={handleChange}
              isInvalid={touched.email && errors.email}
            />
            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='role-type' className='mb-3'>
            <Form.Label>Type <span className='required-field'>*</span></Form.Label>
            <Form.Control as="select" name="roleId" onChange={handleChange} isInvalid={touched.typeId && errors.typeId}>
              <option value="">Select one</option>
              {
                roles.length > 0 ? (
                  <>
                  {roles.map((role, i) => (<option key={'roles.' + i} value={role.roleId}>{role.role}</option>))}
                  </>
                ) : (null)
              }
            </Form.Control>
            <Form.Control.Feedback type="invalid">{errors.typeId}</Form.Control.Feedback>
          </Form.Group>
            {submitting ? (
              <Button variant="info" disabled size='sm'><Spinner as="span" animation="border" size="sm"/> Sending...</Button>
            ) : (
              <Button variant="primary" type="submit" size='sm'>Send invite</Button>
            )}
          </Form>
        )}
      </Formik>
      </div>


        ) : (null)}

    
    </div>
  );
}


export default AccountInviteForm;
